/* global AbortController setTimeout clearTimeout */

import { NetworkError } from "../store/NetworkError";
import type { CurrentUser } from "../store/CurrentUser";

/** 応答を待つ上限。起動の途中で待たれるので、返らないまま止まらせない（記録 37）。 */
const CURRENT_USER_TIMEOUT_MS = 15_000;

/**
 * /user-tokens/me。auth_access Cookie を `credentials: 'include'` で送信し、
 * ログイン中ユーザーの情報を取得する。
 *
 * - 200: `CurrentUser` を返す
 * - 401: `null` を返す (未認証 / 期限切れ)。呼び出し側が再認証フローへ誘導
 * - ネットワーク失敗: `NetworkError` throw
 */
export async function getCurrentUser(): Promise<CurrentUser | null> {
    let res: Response;
    // **上限を付ける。** これは起動の途中で待たれるので、応答が返らない回線では
    // タスクペインが永久に白いままだった（記録 37）。切れた側は未認証として扱えば
    // ログイン画面が出て、利用者が自分で試し直せる。
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), CURRENT_USER_TIMEOUT_MS);
    try {
        res = await fetch("/user-tokens/me", {
            method: "GET",
            credentials: "include",
            headers: { Accept: "application/json" },
            signal: controller.signal,
        });
    } catch (e) {
        throw new NetworkError(e instanceof Error ? e.message : "Network error");
    } finally {
        clearTimeout(timer);
    }
    if (res.status === 401) return null;
    if (!res.ok) throw new Error(`me failed with status ${res.status}`);
    return (await res.json()) as CurrentUser;
}
